<template>
  <v-col :cols="12">
    <h3>Block Thumbnail Image</h3>
    <FileInput
      :canShowDiffIcon="canShowDiffIcon"
      :fileAcceptType="fileAcceptedTypes"
      :label="coverImagePlaceholder"
      :isRequired="isAssetUploadRequired"
      :fileChangeHandler="
        (file) =>
          fileUploadHandler(
            file,
            isAssetUploadRequired ? data.imageUrl : data.briefUrl,
            isAssetUploadRequired ? 'assetId' : 'briefAssetId'
          )
      "
      :previewUrl="previewUrl"
      :previewUrlBrief="previewUrlBrief"
      :image_url="data.imageUrl"
      :image_url_brief="data.briefUrl"
      :isNotReadOnly="isNotReadOnly"
      :loadingStatus="loadingStatus == 'in_progress'"
      :clearable="true"
      :isAssetUploadRequired="isAssetUploadRequired"
      @addBriefToAsset="
        (previewUrl, briefUrl, approveAsset) =>
          addToAsset(previewUrl, briefUrl, approveAsset, 'blockImage', -1)
      "
      :diffIdentifier="isAssetUploadRequired ? 'imageUrl' : 'briefUrl'"
      :canAppproveAsset="canAppproveAsset"
      :isAssetApproved="data.imageUrlApproved || false"
      :canFinalizeAsset="true"
      :fileValidators="fileValidators"
      :ApproveAssetAndEmitResult="true"
      @assetApprovedByUser="(val) => $emit('assetApprovedByUser', val)"
    /><br />
    <RichTextEditor
      :readonly="!isNotReadOnly || isAssetUploadRequired"
      :canShowDiffIcon="canShowDiffIcon"
      fieldIdentifier="brief"
      :placeholder="'Brief'"
      v-model="data.brief"
      :key="`confidenceBlockImageBrief`"
      :counter="3000"
      :allowWordCount="false"
      :allowCharacterCount="true"
      :includeOnlyToolBarActions="allowedToolBarActionWithTablesForRTE"
      :showValidationError="isValidationRequired"
    />
  </v-col>
</template>

<script>
import FileInput from '@/components/inputs/FileInput';
import RichTextEditor from '@/components/RTE/RichTextEditor';
import Errors from '@/constants/Errors';

export default {
  name: 'ConfidenceThumbnailImage',
  data() {
    return {
      Errors,
    };
  },
  components: {
    FileInput,
    RichTextEditor,
  },
  props: {
    coverImagePlaceholder: { type: String, required: true },
    previewUrl: { type: String, required: false, default: '' },
    previewUrlBrief: { type: String, required: false, default: '' },
    fileChangeHandler: { type: Function, required: true },
    canShowDiffIcon: { type: Boolean, required: true },
    showImageBrief: { type: Boolean, required: true },
    isNotReadOnly: { type: Boolean, required: false, default: true },
    loadingStatus: { type: String, required: false, default: '' },
    data: { type: Object, required: true },
    isAssetUploadRequired: { type: Boolean, required: true },
    canAppproveAsset: { type: Boolean, default: false },
    validationFlag: { type: Boolean, default: false },
    fileAcceptedTypes: {
      type: String,
      required: true,
    },
    addToAsset: { type: Function, required: true },
    allowedToolBarActionWithTablesForRTE: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isValidationRequired() {
      return !this.isAssetUploadRequired && this.validationFlag;
    },
    fileValidators() {
      const FILE_SIZE_50_MB = 50 * 1024 * 1024;
      const FILE_SIZE_150_MB = 150 * 1024 * 1024;
      const error150mb = 'File size must be < 150 MB.';
      const error50mb = 'File size must be < 50 MB.';
      const defaultValidator = (file) => (file && file.size > FILE_SIZE_50_MB ? error50mb : true);

      if (this.subjectName == 'English') {
        return [
          (file) => {
            if (file) {
              if (file.type.includes('video/')) {
                if (file.size > FILE_SIZE_150_MB) {
                  return error150mb;
                }
              } else {
                if (file.size > FILE_SIZE_50_MB) {
                  return error50mb;
                }
              }
            }
          },
        ];
      } else {
        return [defaultValidator];
      }
    },
  },
  methods: {
    fileUploadHandler(file, type, path) {
      if (file == null) {
        this.fileChangeHandler(file, type, path);
        return true;
      }
      let pattern = this.fileAcceptedTypes;
      let errorText = '';
      if (this.isAssetUploadRequired) {
        pattern = 'image/*';
        errorText = ' please upload an image file';
      } else {
        errorText = ' please upload an image or document file';
      }
      if (!(file.type.startsWith('image') || pattern.includes(file.name.split('.').pop()))) {
        this.$notify({
          title: 'Error!',
          text: `File format not supported, ${errorText}`,
          type: 'error',
          clean: false,
          duration: -1,
        });
      } else {
        this.fileChangeHandler(file, type, path);
      }
    },
  },
};
</script>
